import "./PopupWetenschappelijkOnderzoek.scss";
import { AiOutlineClose, AiOutlineDownload } from "react-icons/ai";

export const PopupWetenschappelijkOnderzoek = ({
  closePopupHandler,
  ...props
}) => {
  return (
    <div className="c-detail-fiche--wetenschappelijk-onderzoek">
      <div className="c-detail-fiche--wetenschappelijk-onderzoek__header">
        <div
          className="popupClosingIconContainer"
          onClick={() => closePopupHandler()}
        >
          <AiOutlineClose className="popupClosingIcon" />
        </div>
        {props.data?.detailBannerVideo ? (
          <div
            dangerouslySetInnerHTML={{ __html: props.data?.detailBannerVideo }}
          ></div>
        ) : (
          props.data?.detailImage && (
            <img
              src={props.data.detailImage.url}
              alt={props.data.detailImage.alt}
            />
          )
        )}
      </div>
      <div className="c-detail-fiche--wetenschappelijk-onderzoek__body">
        <div className="c-detail-fiche--wetenschappelijk-onderzoek__body__title">
          <h2>{props.data.title}</h2>
        </div>
        <div>
          <p>{props.data.text}</p>
        </div>
        <div className="c-detail-fiche--wetenschappelijk-onderzoek__body__info">
          {props.data?.detailSideBar && (
            <ul>
              {/* Table with: Organisaties, Authors, year, partners */}
              {props.data.detailSideBar?.organisations?.length > 0 && (
                <li>
                  <WetenschappelijkOnderzoekBodyInfo
                    label={props.dictionary.fwoOrganisations}
                    value={props.data.detailSideBar.organisations}
                  />
                </li>
              )}
              {props.data.detailSideBar?.authors?.length > 0 && (
                <li>
                  <WetenschappelijkOnderzoekBodyInfo
                    label={props.dictionary.fwoAuteurs}
                    value={props.data.detailSideBar.authors}
                  />
                </li>
              )}
              {props.data.detailSideBar?.period && (
                <li>
                  <WetenschappelijkOnderzoekBodyInfo
                    label={props.dictionary.fwoJaar}
                    value={props.data.detailSideBar.period}
                  />
                </li>
              )}
              {props.data.detailSideBar?.partners?.length > 0 && (
                <li>
                  <WetenschappelijkOnderzoekBodyInfo
                    label={props.dictionary.fwoPartners}
                    value={props.data.detailSideBar.partners}
                  />
                </li>
              )}
            </ul>
          )}
        </div>
        {props.data.detailBody.intro?.length > 0 && (
          <div className="c-detail-fiche--wetenschappelijk-onderzoek__body__intro">
            <p>{props.data.detailBody.intro}</p>
          </div>
        )}
        {props.data.detailBody.description?.length > 0 && (
          <div className="c-detail-fiche--wetenschappelijk-onderzoek__body__description">
            <p>{props.data.detailBody.description}</p>
          </div>
        )}

        {props.data.detailBody.links?.length > 0 && (
          <div className="c-detail-fiche--wetenschappelijk-onderzoek__body__property">
            <ul>
              {props.data.detailBody.links.map((link, i) => {
                return (
                  <li>
                    <a
                      href={link.url}
                      className="c-link--icon"
                      target={link.target}
                    >
                      {link.title}
                      <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        <div className="c-detail-fiche--wetenschappelijk-onderzoek__footer">
          Meer weten? Contacteer{" "}
          <a
            className="fs-inherit"
            href={`mailto:${props.data.detailContactAddress}`}
          >
            {props.data.detailContactAddress}
          </a>
        </div>
      </div>
    </div>
  );
};

const WetenschappelijkOnderzoekBodyInfo = ({
  label,
  value,
  tooltipText,
  ...props
}) => {
  if (Array.isArray(value) && value.length !== 0) {
    value = value.map((val, i) => {
      return <span>{`${val}${i + 1 < value.length ? ", " : ""}`}</span>;
    });
  }
  return (
    <div class="row">
      <div class="c-detail-fiche--wetenschappelijk-onderzoek__body__info__label col-md-6">
        {label}
      </div>
      <div class="c-detail-fiche--wetenschappelijk-onderzoek__body__info__value no-icon col-md-6">
        <span className="c-detail-fiche--wetenschappelijk-onderzoek__body__info__value__text">
          {value}
        </span>
      </div>
    </div>
  );
};
